import { render, staticRenderFns } from "./ListBaseWithSearch.vue?vue&type=template&id=8f0f9d6e&scoped=true&"
import script from "./ListBaseWithSearch.vue?vue&type=script&lang=js&"
export * from "./ListBaseWithSearch.vue?vue&type=script&lang=js&"
import style0 from "./ListBaseWithSearch.vue?vue&type=style&index=0&id=8f0f9d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0f9d6e",
  null
  
)

export default component.exports